import React from 'react'
import './BookMyTable.css';
import { Link } from 'react-router-dom';
import { useStateValue } from './StateProvider';

function BookMyTable() {
    const [{ basket }, dispatch] = useStateValue(); 

    // console.log('This is the basket >>> ', basket);

    const addToBasket = () => {
        // dispatch the item into the data layer
        dispatch({
            type: 'ADD_TO_BASKET',
            item: {
                
            }
        })
    }
    return (
        <div className="bookmytable">
                <div className="hotel_1_imgs">
                    <img className="htl_1_pht_1" src="/images/Photo-1.jpg"></img>
                    <img className="htl_1_pht_2" src="/images/Photo-2.jpg"></img>
                    <img className="htl_1_pht_3" src="/images/Photo-3.jpg"></img>
                    <img className="htl_1_pht_4" src="/images/Photo-4.jpg"></img>
                </div>
                
                <h2 className="htl_1_name">XYZ Restaurant</h2>
                <h3 className="htl_1_spc">Continental, Chinese, Punjabi</h3>
                <h3 className="htl_1_add">Dubai</h3>
                <h3 className="htl_1_bmt">Book My Table</h3>

                <div className="htl_1_tables">
                    <Link>
                    <img className="htl_1_tbl_1" src="/images/dine-table(2).jpg" />
                    </Link>
                    <h3 className="tbl_1_2per">2 Person</h3>
                    <Link>
                    <img className="htl_1_tbl_2" src="/images/dine-table(2).jpg" />
                    </Link>
                    <h3 className="tbl_2_2per">2 Person</h3>
                    <Link>
                    <img className="htl_1_tbl_3" src="/images/dine-table(8).jpg" />
                    </Link>
                    <h3 className="tbl_3_8per">8 Person</h3>
                    <Link>
                    <img className="htl_1_tbl_4" src="/images/dine-table(8).jpg" />
                    </Link>
                    <h3 className="tbl_4_8per">8 Person</h3>
                    <Link>
                    <img className="htl_1_tbl_5" src="/images/dine-table(2).jpg" />
                    </Link>
                    <h3 className="tbl_5_2per">2 Person</h3>
                    <Link>
                    <img className="htl_1_tbl_6" src="/images/dine-table(2).jpg" />
                    </Link>
                    <h3 className="tbl_6_2per">2 Person</h3>
                    <Link>
                    <img className="htl_1_tbl_7" src="/images/dine-table(4).jpg" />
                    </Link>
                    <h3 className="tbl_7_4per">4 Person</h3>
                    <Link>
                    <img className="htl_1_tbl_8" src="/images/dine-table(4).jpg" />
                    </Link>
                    <h3 className="tbl_8_4per">4 Person</h3>
                    <Link>
                    <img className="htl_1_tbl_9" src="/images/dine-table(6).jpg" />
                    </Link>
                    <h3 className="tbl_9_6per">6 Person</h3>
                    <Link>
                    <img className="htl_1_tbl_10" src="/images/dine-table(6).jpg" />
                    </Link>
                    <h3 className="tbl_10_6per">6 Person</h3>
                    <Link>
                    <img className="htl_1_tbl_11" src="/images/dine-table(6).jpg" />
                    </Link>
                    <h3 className="tbl_11_6per">6 Person</h3>
                    <Link>
                    <img className="htl_1_tbl_12" src="/images/dine-table(6).jpg" />
                    </Link>
                    <h3 className="tbl_12_6per">6 Person</h3>
                </div>
                <div className="dishes">
                    <p className="menu">Menu</p>

                    <img className="manchurian" src="images/Manchurian.png"></img>
                    <h3 className="dish_1">Manchurian</h3>
                    <button className="dish_1_btn" onClick={addToBasket}>Add +</button>

                    <img className="soup" src="images/Soup.png"></img>
                    <h3 className="dish_2">Soup</h3>
                    <button className="dish_2_btn">Add +</button>

                    <img className="cheese-balls" src="images/Cheese Balls.png"></img>
                    <h3 className="dish_3">Cheese Balls</h3>
                    <button className="dish_3_btn">Add +</button>

                    <img className="corn-tikki" src="images/corn tikki.png"></img>
                    <h3 className="dish_4">Corn Tikki</h3>
                    <button className="dish_4_btn">Add +</button>

                    <img className="mutter-paneer" src="images/Mutter Paneer.jpg"></img>
                    <h3 className="dish_5">Corn Tikki</h3>
                    <button className="dish_5_btn">Add +</button>

                </div>
            </div>
    )
}

export default BookMyTable
